import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';

import CheckboxEmpty from '../../../assets/icons/CheckboxEmpty';
import CheckboxFull from '../../../assets/icons/CheckboxFull';
import theme from '../../../assets/theme';
import { Button } from '../../_atoms/Button';
import { Center } from '../../_atoms/Center';

const CheckListItemCard = ({
  items,
  title,
  audience,
  subTitle,
  actionButtonText,
  actionButtonRedirect,
  isExternal = false,
  readMore,
}: {
  items: { checked: boolean; text: string }[];
  title: string;
  audience: string;
  subTitle: React.ReactNode;
  actionButtonText: string;
  actionButtonRedirect: string;
  isExternal?: boolean;
  readMore?: { path: string; text: string };
}) => {
  const actionButton = isExternal ? (
    <a
      href={actionButtonRedirect}
      // onClick={() =>
      //   trackCustomEvent({
      //     // string - required - The object that was interacted with (e.g.video)
      //     category: 'CheckListItemCard',
      //     // string - required - Type of interaction (e.g. 'play')
      //     action: 'Click',
      //     // string - optional - Useful for categorizing events (e.g. 'Spring Campaign')
      //     label: `CheckListItemCard.${title}`,
      //   })
      // }
    >
      <Button type="primary">{actionButtonText}</Button>
    </a>
  ) : (
    <Link
      href={actionButtonRedirect}
      passHref
      // onClick={() =>
      //   trackCustomEvent({
      //     // string - required - The object that was interacted with (e.g.video)
      //     category: 'CheckListItemCard',
      //     // string - required - Type of interaction (e.g. 'play')
      //     action: 'Click',
      //     // string - optional - Useful for categorizing events (e.g. 'Spring Campaign')
      //     label: `CheckListItemCard.${title}`,
      //   })
      // }
    >
      <a>
        <Button type="primary">{actionButtonText}</Button>
      </a>
    </Link>
  );
  return (
    <Card>
      <p
        style={{
          fontWeight: 'bold',
          fontSize: 32,
          width: '100%',
          color: theme.colors.black,
          textAlign: 'center',
          lineHeight: '36px',
        }}
      >
        {title}
      </p>

      <h1
        style={{
          fontWeight: 'bold',
          fontSize: 50,
          width: '100%',
          color: theme.colors.black,
          textAlign: 'center',
          marginTop: 0,
        }}
      >
        {subTitle}
      </h1>
      <p
        style={{
          fontWeight: 'bold',
          fontSize: 18,
          width: '100%',
          color: theme.colors.black,
          textAlign: 'center',
          lineHeight: '36px',
        }}
      >
        {audience}
      </p>
      {items.map(item => (
        <GDPRItemContainer key={item.text}>
          <IconWrapper>{item.checked ? <CheckboxFull /> : <CheckboxEmpty />}</IconWrapper>
          <span>{item.text}</span>
        </GDPRItemContainer>
      ))}

      <Center style={{ paddingTop: 40 }}>{actionButton}</Center>
      {readMore && (
        <Center style={{ paddingTop: 20 }}>
          <Link href={readMore.path} passHref>
            <a>{readMore.text}</a>
          </Link>
        </Center>
      )}
    </Card>
  );
};

export default CheckListItemCard;

const Card = styled.div`
  display: flex;
  max-width: 450px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  border-radius: 20px;
  height: 100%;
  width: 100%;
  background: white;
  padding: 40px 20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  h3 {
    margin-top: 20px;
    margin-bottom: 20px;
    font-weight: bold;
  }
`;

const IconWrapper = styled.div`
  flex: 0;
  display: flex;
  align-items: center;
  svg {
    height: 40px;
    width: 40px;
    margin-right: 20px;
  }
`;

const GDPRItemContainer = styled.div`
  width: 100%;
  min-height: 45px;
  height: auto;
  display: flex;
  align-items: center;

  span {
    flex: 1;
    flex-wrap: word-wrap;
    font-size: 16px;
    font-weight: bold;
    color: ${theme.colors.black};
  }
`;
